import { render, staticRenderFns } from "./reports-view.vue?vue&type=template&id=f8993a0c&"
import script from "./reports-view.vue?vue&type=script&lang=js&"
export * from "./reports-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports